import React from "react";
import { RegisterContent } from "src/content";

const NewRegister = () => {
  return (
    <div>
      <RegisterContent />
    </div>
  );
};

export default NewRegister;
